function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-208.429 -178.591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.843,195.486c-1.889,0-3.779,0-5.668,0a2.6,2.6,0,0,1-2.738-2.715c0-2.571.01-5.142-.008-7.713a2.19,2.19,0,0,1,1.017-1.95q3.06-2.057,6.136-4.089a2.172,2.172,0,0,1,2.587,0q3.072,2.037,6.136,4.088a2.189,2.189,0,0,1,1.017,1.95c-.015,2.593,0,5.186-.008,7.779a2.59,2.59,0,0,1-2.673,2.648C220.708,195.491,218.775,195.486,216.843,195.486Zm-.018-2.108q2.734,0,5.467,0c.779,0,.916-.139.917-.924,0-2.329-.01-4.657.011-6.986a.879.879,0,0,0-.474-.838c-1.8-1.177-3.591-2.364-5.361-3.582a.781.781,0,0,0-1.043.018q-2.662,1.818-5.363,3.582a.822.822,0,0,0-.446.786c.02,2.35.007,4.7.011,7.051,0,.743.146.891.88.892C213.225,193.381,215.025,193.378,216.825,193.378Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.04,191.779h-8.331v-2.052h8.331Z"
}));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1899ae",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.893,
    height: 16.896,
    viewBox: "0 0 16.893 16.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.db6906cd1fb214c00ec8549c252d2d68.svg";
export { ForwardRef as ReactComponent };